// import { AxiosError } from 'axios';
import { toast } from 'react-toastify';

import { uniqueId } from 'lodash';
import api from '../../api';
import { Folder } from './types';

export async function getFoldersRequest() {
  try {
    const response = await api().get('/folders');

    return response.data;
  } catch (error) {
    // const errorStatus = error as AxiosError;
    // switch (errorStatus.response?.status) {
    //   case 401:
    //     setTokensLocalStorage(null);
    //     return null;
    //   default:
    //     return null;
    // }
    console.error(error);
    return null;
  }
}

export async function getFoldersByFolderIdRequest(
  baseConhecimentoId: string,
  userId: string,
) {
  try {
    const response = await api().get(`/folders/${baseConhecimentoId}`, {
      headers: { userId },
    });

    return response;
  } catch (error) {
    // const errorStatus = error as AxiosError;
    // switch (errorStatus.response?.status) {
    //   case 401:
    //     setTokensLocalStorage(null);
    //     return null;
    //   default:
    //     return null;
    // }
    console.error(error);
    return null;
  }
}

export async function getFoldersStructureByFolderIdRequest(
  userId: string,
  companyId: string,
  local: 'manual' | 'automatic' | string,
) {
  try {
    const response = await api().get(`/folders/folders-structure`, {
      headers: { userId, companyId, local },
    });

    return response;
  } catch (error) {
    console.error('Error getFoldersStructureByFolderIdRequest => ', error);
    return null;
  }
}

export async function getFolderByUserIdRequest(userId: string) {
  try {
    const response = await api().get(`/folders/user/${userId}`);

    return response?.data;
  } catch (error) {
    // const errorStatus = error as AxiosError;
    // switch (errorStatus.response?.status) {
    //   case 401:
    //     setTokensLocalStorage(null);
    //     return null;
    //   default:
    //     return null;
    // }
    console.error(error);
    return null;
  }
}

export async function getAutomaticsFoldersByUserId(
  userId: string,
  companyId: string,
) {
  try {
    const response = await api().get(`/folders/automatics/${userId}`, {
      headers: {
        companyId,
      },
    });

    return response;
  } catch (error) {
    console.error(error);
    return null;
    // const errorStatus = error as AxiosError;
    // switch (errorStatus.response?.status) {
    //   case 401:
    //     setTokensLocalStorage(null);
    //     return null;
    //   default:
    //     return null;
    // }
    // return false;
  }
}

export async function getManualsFoldersByUserId(
  userId: string,
  companyId: string,
) {
  try {
    const response = await api().get(`/folders/manuals/${userId}`, {
      headers: {
        companyId,
      },
    });

    return response;
  } catch (error) {
    // const errorStatus = error as AxiosError;
    // switch (errorStatus.response?.status) {
    //   case 401:
    //     setTokensLocalStorage(null);
    //     return null;
    //   default:
    //     return null;
    //   }
    return null;
  }
}

export async function createFolderRequest(
  baseConhecimento: Partial<Folder>,
  userId: string,
  companyId: string,
  inFolderId: string,
) {
  try {
    const data = {
      ...baseConhecimento,
      owner_id: userId,
    };
    const response = await api().post('/folders', data, {
      headers: {
        companyId,
        userId,
        inFolderId,
      },
    });

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }

    // const errorStatus = error as AxiosError;
    // switch (errorStatus.response?.status) {
    //   case 401:
    //     setTokensLocalStorage(null);
    //     return null;
    //   default:
    //     return null;
    // }
    console.error(error);
    return null;
  }
}

export async function moveFolder(
  itemSelected: string,
  folderToMoveId: string,
  isFolder: boolean,
) {
  try {
    const response = await api().post(
      '/folders/move',
      {},
      {
        headers: {
          itemSelected,
          folderToMoveId,
          isFolder,
        },
      },
    );

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }

    // const errorStatus = error as AxiosError;
    // switch (errorStatus.response?.status) {
    //   case 401:
    //     setTokensLocalStorage(null);
    //     return null;
    //   default:
    //     return null;
    // }
    console.error(error);
    return null;
  }
}

export async function updateFolderRequest(
  folder: Partial<Folder>,
  folderId: string,
  userId: string,
  companyId: string,
) {
  try {
    const data = {
      ...folder,
    };
    const response = await api().patch(`/folders/${folderId}`, data, {
      headers: {
        companyId,
        userId,
      },
    });

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }

    // const errorStatus = error as AxiosError;
    // switch (errorStatus.response?.status) {
    //   case 401:
    //     setTokensLocalStorage(null);
    //     return null;
    //   default:
    //     return null;
    // }
    console.error(error);
    return null;
  }
}

export async function removeFolderRequest(
  folderId: string,
  userId: string,
  companyId: string,
) {
  try {
    const response = await api().patch(
      `/folders/remove/${folderId}`,
      {},
      {
        headers: {
          companyId,
          userId,
        },
      },
    );

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }

    // const errorStatus = error as AxiosError;
    // switch (errorStatus.response?.status) {
    //   case 401:
    //     setTokensLocalStorage(null);
    //     return null;
    //   default:
    //     return null;
    // }
    console.error(error);
    return null;
  }
}

// export async function deleteFolderRequest(
//   folderId: string,
//   companyId: string,
//   userId: string,
// ) {
//   try {
//     const response = await api().delete(`/folders/${folderId}`, {
//       headers: {
//         companyId,
//         userId,
//       },
//     });

//     return response;
//   } catch (error: any) {
//     if (error.response.status === 500) {
//       toast.error('Erro desconhecido, contate o suporte', {
//         toastId: uniqueId(),
//       });
//     } else {
//       toast.error(error.response.data.message, {
//         toastId: uniqueId(),
//       });
//     }

//     // const errorStatus = error as AxiosError;
//     // switch (errorStatus.response?.status) {
//     //   case 401:
//     //     setTokensLocalStorage(null);
//     //     return null;
//     //   default:
//     //     return null;
//     // }
//     console.error(error);
//     return null;
//   }
// }

export async function postFolderZipRequest(
  fileKey: string,
  fileName: string,
  companyId: string,
  userId: string,
  folderId: string,
) {
  try {
    const response = await api().post(
      `folders/zip`,
      {},
      {
        headers: {
          fileKey,
          fileName,
          companyId,
          userId,
          folderId,
        },
      },
    );

    return response;
  } catch (err: any) {
    console.log(err);
    if (err.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(err.response.data.message, {
        toastId: uniqueId(),
      });
    }

    return null;
  }
}
